import { Box, SkeletonRectangle } from '@wix/design-system';
import React from 'react';

const FEATURE_COUNT = 3;

export const HeaderSkeleton = () => {
  return (
    <>
      <Box
        width="100%"
        maxWidth="1140px"
        padding="0 12px"
        marginTop="SP2"
        marginLeft="SP2"
      >
        <SkeletonRectangle
          height="24px"
          width="120px"
          dataHook="logo-skeleton"
        />
      </Box>
      <Box
        direction="vertical"
        width="100%"
        align="center"
        gap="SP4"
        marginTop="SP7"
      >
        <Box width="100%" maxWidth="1140px" padding="0 12px" align="center">
          <SkeletonRectangle
            height="16px"
            width="200"
            dataHook="subtitle-skeleton"
          />
        </Box>
        <Box width="100%" maxWidth="1140px" padding="0 12px" align="center">
          <SkeletonRectangle
            height="32px"
            width="450px"
            dataHook="title-skeleton"
          />
        </Box>
      </Box>
      <Box
        direction="horizontal"
        width="100%"
        maxWidth="1140px"
        gap="SP3"
        marginTop="SP5"
        align="center"
      >
        {Array.from({ length: FEATURE_COUNT }, (_, index) => (
          <SkeletonRectangle
            key={index}
            height="20px"
            width="120px"
            dataHook={`feature-skeleton-${index}`}
          />
        ))}
      </Box>
    </>
  );
};
